<template lang="html">
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    width="16" height="16" viewBox="0 0 16 16">
  <path d="M8 0l-8 8 8 8 8-8-8-8zM2 8l6-6 6 6-6 6-6-6z"></path>
  </svg>


</template>

<script>
export default {
  name: 'GeometryDiamond'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/GeometryDiamond.vue